exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".margin-left-2[data-v-3b3f880c]{margin-left:4px}.margin-left-2[data-v-3b3f880c]:first-child{margin-left:0}", ""]);

// exports
